import type { ProductSearchDescriptors } from '~/features/catalog-operations/types/catalog-operations.types';

/** Flattens every pivot's associated phrases into one `", "`-joined string —
 *  flattened first so each separator is consistent (nested arrays would
 *  `toString()` with a bare `","`). Empty when there are no phrases. */
export function joinSearchPhrases(searchDescriptors: ProductSearchDescriptors | null | undefined) {
  return (
    searchDescriptors?.searchPhrases
      .flatMap((pivot) => pivot.associatedPhrases.map((p) => p.phrase))
      .join(', ') ?? ''
  );
}

/**
 * Builds the "Search Descriptors" form of the description field:
 * `<default description> | <phrases>`. The phrases are appended to the
 * DEFAULT (pre-enrichment) description, never the enriched one — that is the
 * copy the descriptor step augments. A single trailing period is dropped so it
 * reads "...for work | phrase" rather than "...for work. | phrase". Either side
 * missing collapses to the other, with no dangling separator.
 */
export function composeSearchDescriptorDescription(
  defaultDescription: string | null | undefined,
  phrases: string,
): string {
  const base = (defaultDescription ?? '').trim();
  if (!phrases) return base;
  if (!base) return phrases;
  return `${base.replace(/\.$/, '')} | ${phrases}`;
}
